import React from 'react';
import {PageHead} from "widgets/PageHead";
import {InstituteBlock} from "widgets/InstituteBlock";


 const InstitutePage = () => {
    return (
        <>
            <PageHead  title={"Інститут"} imgId={16292}/>
            <InstituteBlock/>
        </>
    );
};
export default InstitutePage
